export const isPreviewRuntime = () => {
  if (typeof window === 'undefined') {
    return false;
  }

  const hostname = window.location.hostname || '';
  return (
    hostname.includes('emergentagent.com') ||
    hostname.includes('e2b.dev') ||
    hostname.includes('localhost') ||
    hostname.includes('127.0.0.1')
  );
};

export default {
  isPreviewRuntime,
};